import React from 'react';
import contactImg from '../../images/sections/contact.png';

const ContactSection = ({ t }) => {
  return (
    <section className="contact" id="contact">
      <div className="contact__content">
        <div className="contact__eyebrow">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <h2>{t.contact.title}</h2>
        <div className="contact__list">
          <div className="contact__item">
            <span className="contact__icon" aria-hidden="true" />
            <span>+30 6971597029</span>
          </div>
          <div className="contact__item">
            <span className="contact__icon" aria-hidden="true" />
            <span>bioregano1@gmail.com</span>
          </div>
          <div className="contact__item">
            <span className="contact__icon" aria-hidden="true" />
            <span>www.biokaliergia.gr</span>
          </div>
          <div className="contact__item">
            <span className="contact__icon" aria-hidden="true" />
            <span>{t.contact.address}</span>
          </div>
        </div>
      </div>
      <div className="contact__image">
        <img src={contactImg} alt="Τηλέφωνο επικοινωνίας" />
      </div>
    </section>
  );
};

export default ContactSection;
